import {Component, Input, OnInit} from '@angular/core';
import {ReporterService} from '@core/services/reporter.service';
import {User} from '@shared/models/user';
import {UserService} from '@core/services/user.service';
import {TeamService} from '@core/services/team.service';
import {LeagueService} from '@core/services/league.service';
import {ReporterButtonsService} from '@core/services/reporter-button/reporter-buttons.service';
import {TypeService} from '@core/services/type.service';
import {PageType} from '../../../../../page-type';

@Component({
  selector: 'app-desktop-reporter-news-card',
  templateUrl: './desktop-reporter-news-card.component.html',
  styleUrls: ['./desktop-reporter-news-card.component.scss']
})
export class DesktopReporterNewsCardComponent implements OnInit {

  @Input() onHomeNewsPage: boolean = false;
  linkToReporter: string;
  user: User;
  userIsNewsReporter: boolean = false;
  showReporterButtons: boolean = false;
  showMobileCard: boolean = true;
  nameOfTeam: string = '';

  constructor( private reporterService: ReporterService,
               private userService: UserService,
               private teamService: TeamService,
               private leagueService: LeagueService,
               private reporterButtonsService: ReporterButtonsService ) { }

  ngOnInit(): void {
    this.linkToReporter = this.reporterService.getReporterNewsWebsiteLink();
    this.user = this.userService.currentUser;
    this.checkIfReporterButtonsShouldBeShown();
  }

  openNewsReporterWebsite() {
    this.reporterService.openReporterNewsWebsite(true);
  }

  private checkIfReporterButtonsShouldBeShown() {
    this.showReporterButtons = true;
    if (this.reporterButtonsService.userIsNewsReporter(this.user)) {
      this.showReporterButtons = true;
      this.showMobileCard = false;
      this.userIsNewsReporter = true;
    } else if (this.teamService.currentTeam != null) {
      this.showReporterButtons = this.reporterButtonsService.checkIfReporterButtonsShouldBeShownOnTeamPage(
        this.user,
        this.teamService.currentTeam
      );
      if (this.showReporterButtons) {
        this.nameOfTeam = this.teamService.currentTeam.name;
      }
    } else if (this.leagueService.currentLeague != null) {
      this.leagueService.fetchLeagueTeams(this.leagueService.currentLeague.id).then(teams => {
        const returnValue = this.reporterButtonsService.checkIfReporterButtonsShouldBeShownOnLeaguePage(
          this.user,
          this.leagueService.currentLeague,
          teams
        );
        this.showReporterButtons = returnValue.showButtons;
        this.nameOfTeam = returnValue.teamName;
      });
    } else {
      this.showReporterButtons = false;
      this.userIsNewsReporter = false;
    }
  }
}
